/**
 * @file 异步请求业务错误类（增强版，结合 ky hook / 全局错误处理）
 * @description 封装 HTTP 状态码与业务错误码，便于统一处理 401 / 403 / message 等逻辑
 * @author sunyingying01
 */

type CodeType = string | number | boolean | Record<string, unknown> | unknown[];

export interface IBizErrorPops {
    statusCode: number;
    code: CodeType;
    response: Response;
    data?: unknown;
}

export class BizError extends Error {
    statusCode: number;
    code: CodeType;
    response: Response;
    data?: unknown;

    constructor(message: string, props: IBizErrorPops) {
        super(message || '业务请求异常');

        this.name = 'BizError';
        this.statusCode = props.statusCode;
        this.code = props.code;
        this.response = props.response;
        this.data = props.data;

        Object.setPrototypeOf(this, BizError.prototype);
    }

    toString() {
        return `[BizError] ${this.message} (HTTP ${this.statusCode}, Code: ${String(this.code)})`;
    }

    toJSON() {
        return {
            name: this.name,
            message: this.message,
            statusCode: this.statusCode,
            code: this.code,
            data: this.data
        };
    }
}
